import { render, staticRenderFns } from "./CardVerVotantesxPersonal.vue?vue&type=template&id=07065981&scoped=true"
import script from "./CardVerVotantesxPersonal.vue?vue&type=script&lang=js"
export * from "./CardVerVotantesxPersonal.vue?vue&type=script&lang=js"
import style0 from "./CardVerVotantesxPersonal.vue?vue&type=style&index=0&id=07065981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07065981",
  null
  
)

export default component.exports